import { PerformanceTier } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import { DisplayTier } from './types';
import wingsSilverLeftImg from './assets/wings-silver-left.png';
import wingsSilverRightImg from './assets/wings-silver-right.png';
import wingsGoldLeftImg from './assets/wings-gold-left.png';
import wingsGoldRightImg from './assets/wings-gold-right.png';

export const BOLT_STAR_ROUTE = '/analytics/boltStar';

/** Ordering used to decide whether a benefit's unlock_tier has been reached. */
export const TIER_RANK: Record<DisplayTier, number> = {
  ineligible: 0,
  needs_improvement: 1,
  good: 2,
  top: 3,
};

/** Performance tiers in the left-to-right order the comparison tables show them. */
export const TIER_ORDER: PerformanceTier[] = [
  PerformanceTier.NEEDS_IMPROVEMENT,
  PerformanceTier.GOOD,
  PerformanceTier.TOP,
];

export const TIER_ORDER_REVERSE = [...TIER_ORDER].reverse();

interface TierMeta {
  leftIcon?: string;
  rightIcon?: string;
}

export const TIER_META: Record<DisplayTier, TierMeta> = {
  ineligible: {},
  needs_improvement: {},
  good: { leftIcon: wingsSilverLeftImg, rightIcon: wingsSilverRightImg },
  top: { leftIcon: wingsGoldLeftImg, rightIcon: wingsGoldRightImg },
};
